// extracted by mini-css-extract-plugin
module.exports = {"navButtons":"AdacCallbackOptionsPage_navButtons__0Bh7r"};